var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseRemoteService } from "../core/BaseRemoteService";
import { toGroupedSelectList } from "../../utils/listHelpers";
export class GeneralConditionsService extends BaseRemoteService {
    getAll() {
        const _super = Object.create(null, {
            getRequest: { get: () => super.getRequest }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${this.apiRoot}/generalconditions`;
            const data = yield _super.getRequest.call(this, url);
            return {
                data: toGroupedSelectList(data, {
                    id: "code",
                    name: "description",
                    group: "conditionCategory",
                }).map(item => (Object.assign(Object.assign({}, item), { name: `${item.id} - ${item.name}` }))),
                //.sort((a, b) => (a.id < b.id ? -1 : 1)),
            };
        });
    }
}
